import AthenaSurvey from '@ad/feelgood-sdk'
import { catchableParse } from 'Src/util/json'
import { loginType } from 'Src/const/state/ad'
/**
 * 雅典南-调研问卷初始化
 * 相关官网：https://ad.oceanengine.com/athena/survey/
 * 新版文档：https://bytedance.feishu.cn/wiki/wikcnkEfiyQSkoCTXdEMlhThDHb#
 *
 * @param config Object - 调研sdk默认初始化
 *  - 参考文档 https://doc.bytedance.net/docs/2626/3150/23091/
 * @param setUserInfo Funtion - 自定义新增用户字段
 *  - 返回值 <Object>
 *
 */
export const initAthenaSurvey = (config, setUserInfo) => {
  try {
    let userInfo = {
      // 建议用登录用户id
      user_id: GLOBAL_VAR.coreUser.id,
      // 建议用登录用户名称
      user_name: GLOBAL_VAR.coreUser.adminName,
      advid: GLOBAL_VAR.advertiser.id,
      core_user_id: GLOBAL_VAR.coreUser.id,
      advertiser_id: GLOBAL_VAR.advertiser.id,
      customer_type: GLOBAL_VAR.customerType,
      login_way: (() => {
        switch (true) {
          // 账户密码登录
          case catchableParse(GLOBAL_VAR.isAdmin):
            return loginType.isAdmin
          // 内部系统附身: 内部优化师
          case catchableParse(GLOBAL_VAR.sales):
            return loginType.isStaff
          // 外部系统附身: 代理商 + 账户管家附身
          case catchableParse(GLOBAL_VAR.user_jobbed):
            return loginType.isCoreUser
          default:
            return '0'
        }
      })()
    }
    // 调研sdk初始化
    AthenaSurvey.init(config || {})

    // 自定义新增用户字段
    if (typeof setUserInfo === 'function') {
      userInfo = { ...userInfo, ...(setUserInfo() || {}) }
    }
    AthenaSurvey.setUserInfo(userInfo)

    // 主动启动事件上报（包括行为和表单提交等所有事件）
    // 启动之前收集的事件会被缓存，启动后会先将缓存的事件集中上报
    AthenaSurvey.enableSend()

    // 调研sdk挂载window中
    window.AthenaSurvey = AthenaSurvey
    window.AthenaSurveyId = config.id || ''
    window.AthenaSurveyUserInfo = userInfo
    // 打印调研sdk日志正确信息
    console.log('survey sdk loaded')
  } catch (e) {
    // 打印调研sdk日志错误信息
    console.error('survey sdk error', e)
  }
}
